import React, { Component } from "react";
import { connect } from "react-redux";
import SummaryAdmin from "../components/SummaryAdmin";
import { updateUserData } from "../../../../actions/user.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";
import {
  fetchIndustries,
  getCommuteCities,
  getLevels
} from "../../../../actions/dropdowns.actions";

class SummaryAdminContainer extends Component {
  constructor(props) {
    super(props);

    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchIndustries();
    this.props.getCommuteCities();
    this.props.getLevels();
  }

  handleSubmit(data) {
    if (data.city && data.city.length > 0) {
      data.city = data.city[0].description;
    }

    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "summary");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "summary");
    }
  }

  render() {
    return (
      <SummaryAdmin
        cities={this.props.cities}
        commuteCities={this.props.commuteCities}
        industries={this.props.industries}
        levels={this.props.levels}
        defaultLocation={this.props.defaultLocation}
        isLoading={this.props.isLoading}
        memberId={this.memberId}
        onSubmit={this.handleSubmit}
        searchCitiesAutocomplete={this.props.searchCitiesAutocomplete}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    cities: state.cities.cities.predictions,
    commuteCities: state.dropdowns.commuteCities.data,
    industries: state.dropdowns.industries.data,
    levels: state.dropdowns.levels.data,
    defaultLocation: _.get(state, "user.data.profile.city"),
    isLoading: state.cities.cities.isLoading,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  searchCitiesAutocomplete: query => dispatch(searchCitiesAutocomplete(query)),
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName)),
  fetchIndustries: () => dispatch(fetchIndustries()),
  getCommuteCities: () => dispatch(getCommuteCities()),
  getLevels: () => dispatch(getLevels())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryAdminContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/SummaryAdminContainer.js